<template>
  <img
    v-if="profile==='PROCUREMENT'"
    src="../assets/images/icons/procurement.png"
    :alt="profile"
  >
  <img
    v-else-if="profile==='SUPPLIER'"
    src="../assets/images/icons/supplier.png"
    :alt="profile"
  >
  <img
    v-else-if="profile==='LOGISTIC'"
    src="../assets/images/icons/logistic.png"
    :alt="profile"
  >
  <img
    v-else-if="profile==='TRUCK'"
    src="../assets/images/icons/truck.png"
    :alt="profile"
  >
</template>
<script>
export default {
  name: 'ProfileTypeIcon',
  props: {
    profile: {}
  }
}
</script>
